import {
  frameThickness,
  glassHingeWidth,
  glassHingeHeight,
  glassLockWidth,
  glassLockHeight,
} from '@/shared/config/model-constants'
import type { ModelData } from '@/shared/stores/model-utils'

export const model5InitialModel: ModelData = {
  name: 'Template 5 - Double Door with Side Panels',
  modelId: 'model5',
  type: 'DOOR',
  description: '5-variant door with fixed side panels and double door opening',
  width: 3500,
  height: 2500,
  photoId: null,
  serviceNames: [],
  serviceIds: [],
  parameters: [
    // Frame profiles
    {
      positionId: 'top_frame_profile',
      type: 'PROFILE',
      width: 3500,
      height: frameThickness,
      thickness: 2,
      color: '#ffffff',
      material: '',
      materialId: null,
      position: { x: 0, y: 0, z: 0 },
    },
    {
      positionId: 'bottom_left_frame_profile',
      type: 'PROFILE',
      width: 340,
      height: frameThickness,
      thickness: 2,
      color: '#ffffff',
      material: '',
      materialId: null,
      position: { x: 0, y: 2460, z: 0 },
    },
    {
      positionId: 'bottom_right_frame_profile',
      type: 'PROFILE',
      width: 1540,
      height: frameThickness,
      thickness: 2,
      color: '#ffffff',
      material: '',
      materialId: null,
      position: { x: 1960, y: 2460, z: 0 },
    },
    {
      positionId: 'left_frame_profile',
      type: 'PROFILE',
      width: frameThickness,
      height: 2500,
      thickness: 2,
      color: '#ffffff',
      material: '',
      materialId: null,
      position: { x: 0, y: 0, z: 0 },
    },
    {
      positionId: 'right_frame_profile',
      type: 'PROFILE',
      width: frameThickness,
      height: 2500,
      thickness: 2,
      color: '#ffffff',
      material: '',
      materialId: null,
      position: { x: 3440, y: 0, z: 0 },
    },
    // Glass panels
    {
      positionId: 'left_glass_panel',
      type: 'GLASS',
      width: 280,
      height: 2380,
      thickness: 6,
      color: 'transparent',
      material: ' ',
      materialId: null,
      isDouble: false,
      position: { x: frameThickness, y: frameThickness, z: 0 },
    },
    {
      positionId: 'top_center_glass_panel',
      type: 'GLASS',
      width: 1620,
      height: 400,
      thickness: 6,
      color: 'transparent',
      material: ' ',
      materialId: null,
      isDouble: false,
      position: { x: 340, y: frameThickness, z: 0 },
    },
    {
      positionId: 'left_door_glass_panel',
      type: 'GLASS',
      width: 810,
      height: 2040,
      thickness: 6,
      color: 'transparent',
      material: ' ',
      materialId: null,
      isDouble: false,
      position: { x: 340, y: 460, z: 0 },
      hardware: {
        handles: [
          {
            positionId: 'left_vertical_handle',
            type: 'VERTICAL_HANDLE',
            width: 40,
            height: 200,
            thickness: 10,
            color: '#ffffff',
            material: '',
            materialId: null,
            position: { x: 720, y: 920, z: 10 },
          },
        ],
        hinges: [
          {
            positionId: 'door_1_left_top_hinge_1',
            type: 'HINGE',
            width: glassHingeWidth,
            height: glassHingeHeight,
            thickness: 10,
            color: '#C0C0C0',
            material: '',
            materialId: null,
            position: {
              x: -glassHingeWidth / 3,
              y: -glassHingeHeight / 2,
              z: 10,
            },
          },
          {
            positionId: 'door_1_left_bottom_hinge_2',
            type: 'HINGE',
            width: glassHingeWidth,
            height: glassHingeHeight,
            thickness: 10,
            color: '#C0C0C0',
            material: '',
            materialId: null,
            position: {
              x: 0,
              y: 2040 - glassHingeHeight,
              z: 10,
            },
          },
        ],
        locks: [
          {
            positionId: 'door_1_right_lock',
            type: 'LOCK',
            width: glassLockWidth,
            height: glassLockHeight,
            thickness: 10,
            color: '#C0C0C0',
            material: '',
            materialId: null,
            position: {
              x: 810 - glassLockWidth * 1.5,
              y: 2040 - glassLockHeight,
              z: 10,
            },
          },
        ],
      },
    },
    {
      positionId: 'right_door_glass_panel',
      type: 'GLASS',
      width: 810,
      height: 2040,
      thickness: 6,
      color: 'transparent',
      material: ' ',
      materialId: null,
      isDouble: false,
      position: { x: 1150, y: 460, z: 0 },
      hardware: {
        handles: [
          {
            positionId: 'right_vertical_handle',
            type: 'VERTICAL_HANDLE',
            width: 40,
            height: 200,
            thickness: 10,
            color: '#ffffff',
            material: '',
            materialId: null,
            position: { x: 50, y: 920, z: 10 },
          },
        ],
        hinges: [
          {
            positionId: 'door_2_right_top_hinge_1',
            type: 'HINGE',
            width: glassHingeWidth,
            height: glassHingeHeight,
            thickness: 10,
            color: '#C0C0C0',
            material: '',
            materialId: null,
            position: {
              x: 810 - glassHingeWidth / 2,
              y: -glassHingeHeight / 2,
              z: 10,
            },
          },
          {
            positionId: 'door_2_right_bottom_hinge_2',
            type: 'HINGE',
            width: glassHingeWidth,
            height: glassHingeHeight,
            thickness: 10,
            color: '#C0C0C0',
            material: '',
            materialId: null,
            position: {
              x: 810 - glassHingeWidth,
              y: 2040 - glassHingeHeight,
              z: 10,
            },
          },
        ],
        locks: [
          {
            positionId: 'door_2_left_lock',
            type: 'LOCK',
            width: glassLockWidth,
            height: glassLockHeight,
            thickness: 10,
            color: '#C0C0C0',
            material: '',
            materialId: null,
            position: {
              x: glassLockWidth,
              y: 2040 - glassLockHeight,
              z: 10,
            },
          },
        ],
      },
    },
    {
      positionId: 'right_glass_panel',
      type: 'GLASS',
      width: 1480,
      height: 2380,
      thickness: 6,
      color: 'transparent',
      material: ' ',
      materialId: null,
      isDouble: false,
      position: { x: 1960, y: frameThickness, z: 0 },
    },
  ],
  doorConfiguration: {
    type: 'double_door',
    totalDoorWidth: 1620,
    individualDoorWidth: [810, 810],
    totalHandles: 2,
    openingDirection: 'center_opening',
    hingePosition: 'center_split',
  },
}
